import { NOREPLY_SENDER_EMAIL } from './senderOptions';

/**
 * Het contactadres in de **standaardfooter** gelijkzetten met de afzender van de mail.
 *
 * De standaardfooter komt uit de instellingen (`email_settings.footerHtml`, Instellingen →
 * E-mail) en staat daar met één vast adres in: `ella@yally.be`. Die footer hangt onder élke
 * mail van de composer, ook onder een mail die van een ander postvak vertrekt — en dan
 * klopt het adres niet. Bij een renovatieticket verstuurt de composer vanaf `leo@yally.be`,
 * maar onderaan stond "For questions: ella@yally.be", dus belandde een vraag van een
 * leverancier in het verkeerde postvak en nooit bij het ticket.
 *
 * Elk `@yally.be`-adres in de footer wordt daarom vervangen door het adres waarvan de mail
 * effectief vertrekt (`resolveSenderField(...).email`). Enkel onze eigen adressen: een
 * adres van een leverancier of een externe partij blijft staan. Adressen in de tekst van de
 * gebruiker worden niet aangeraakt — dit geldt alleen voor de footer uit de instellingen.
 *
 * Uitzondering: `noreply@yally.be`. Dat postvak wordt niet gelezen, dus een "stel je vraag
 * hier"-adres zou daar doodlopen; de footer houdt dan zijn eigen adres.
 */
const YALLY_ADDRESS_PATTERN = /[A-Za-z0-9._%+-]+@yally\.be/g;

export const applyFooterSender = (
  footerHtml?: string | null,
  senderEmail?: string | null,
): string => {
  const footer = footerHtml ?? '';
  const sender = senderEmail?.trim();

  if (!footer || !sender) return footer;
  if (sender.toLowerCase() === NOREPLY_SENDER_EMAIL) return footer;

  return footer.replace(YALLY_ADDRESS_PATTERN, sender);
};
